import React from "react";
import { NotesScreenWithBookingData } from "~/features/book-appointment/NotesScreen";

const Component = () => {
  return <NotesScreenWithBookingData />;
};

export default Component;
